
<f-dialog
    v-model       = "value"
    :show-header  = "false"
    :full-screen  = "false"
    :hide-actions = "false"
    :width        = "500"
    @store        = "onStore"
    @cancel       = "onClose"
>
    <template v-slot:content>
        <v-row dense class="mt-1">
            <v-col>
                <v-text-field
                    :label         = "$t('inb.overview.customer.dialog.mailbox')"
                    v-model        = "data.mailbox"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />

                <v-textarea
                    :label         = "$t('inb.overview.customer.dialog.sender')"
                    v-model        = "data.sender"
                    rows           = "10"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    hide-details   = "true"
                    flat
                    no-resize
                />
            </v-col>
        </v-row>
    </template>
</f-dialog>
